import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SupplierActivationExternalUser } from '~/modules/suppliers/externalUser';

import { buildRouteExport } from '~/utils/buildRouteExport';

/**
 * Search params schema for the supplier activation magic link route for external users.
 */
const zodSupplierActivationSearchParamsSchema = z.object({
  token: z.string().trim().min(10),
});

export const Route = createFileRoute(
  '/(custom)/external/data-exchange-activation/$requestId/',
)({
  component: SupplierActivationExternalUser,
  validateSearch: zodSupplierActivationSearchParamsSchema,
});

export const SUPPLIER_ACTIVATION_EXTERNAL = buildRouteExport({ Route });
